<template>
  <div class="basic-layout">

    <header>
      <a href="/">
        <img src="/media/logo-cedi.svg" alt="Sistema de Certificados Digitales"> 
        <h1>
          <span>Sistema de</span>
          <span>Certificados</span>
          <span>Digitales</span>
        </h1> 
      </a>
      <a class="right" target="_blank" href="//uader.edu.ar">
        <img src="/media/logo-uader.svg" alt="Universidad Autónoma de Entre Ríos">
      </a>
      <a class="right" target="_blank" href="//fhaycs-uader.edu.ar">
        <img src="/media/logo-fhaycs.svg" alt="Facultad de Humanidades Artes y Ciencias Sociales">  
      </a>
    </header>


    <child/>

    <footer>
      <small>fhaycscedi v0.1beta © 2019 Dpto. Sis. FHAyCS</small>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'BasicLayout'
}
</script>

<style lang="scss">
.basic-layout {
  color: #000;
  min-height: 100vh;
  padding-bottom: 2rem;
  font-weight: 100;
  position: relative;
  background-position: center;
  background-size: cover;
  width: 100%;
  min-height: 100vh;
  color: #fff;
  font-family: 'Roboto', sans-serif;
  background-image:url('/media/background.jpg');

  &:before {
    content: '';
    background: rgba(0,0,0, 0.3);
    width: 100%;
    height: 100%;
    display: block;
    position:absolute;
    z-index: 0;
  }


  .links > a {
    color: #636b6f;
    padding: 0 25px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: .1rem;
    text-decoration: none;
    text-transform: uppercase;
  }
}


header {
  position: relative;
  top: 0;
  overflow: hidden;
  & h1 {
    & span {
      display: block;
      &:nth-child(1) {
        font-weight: 100;
        font-size: 2.8rem;
      }
      &:nth-child(2) {
        font-weight: 900;
      }
      &:nth-child(3) {
        font-size:4rem;
        line-height: 3.2rem;
      }
    }
    text-transform: uppercase;
    font-size: 2.8rem;
    float: left;
    color: #fff;
    line-height: 2.2rem;
    padding-top: 3vh;
  }
  & .right {
    float: right;
  }
  & img {
    float: left;
    height: 10rem;
    padding: 2vh;
  }
}



footer {
  position:absolute;
  bottom:0;
  right: 1rem;
  color: #fff;
  & small {
    font-size: 1.4rem;
    font-weight: 100;
  }
}

@media only screen and (max-device-width : 600px) {

  header {
    & a:first-child {
      text-align: center;
      display: block;
      & h1 {
        text-align: left;
        margin: 0 10%;
      }
      & img {
        float: none;
      }
    }
    & .right {
      float: none;
      display: inline-block;
      margin:0 6%;
    }
  }

  footer {
    position:relative;
    text-align: right;
    margin-top: 10rem;
  }

}

</style>



// WEBPACK FOOTER //
// resources/assets/js/layouts/basic.vue